// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .bill-pay-select-row table tbody .payment-pending td {\n  cursor: pointer !important;\n}\n[dir] .table-scheduled {\n  background-color: #add8e6 !important;\n}", ""]);
// Exports
module.exports = exports;
